/* gs-strive-hydration-explained — two animation modes:

   1) Mobile (≤991) + motion-allowed: scroll-pinned slide.
      Section becomes a tall scroll track. The .__stage is `position:
      sticky` (browser-native pin, runs on the compositor thread → no JS
      lag). This script writes one CSS variable on the section every
      scroll frame: --slide-progress (0 → 1). The CSS uses it to slide
      the can left and the text panel in from the right simultaneously.

   2) Desktop / no-mobile: original IntersectionObserver per-callout
      reveal (translateX + opacity).

   Reduced-motion / no-JS / unsupported-IO: no-op. The CSS leaves the
   static fallback layout in place. */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 991px)';
  var REDUCED_QUERY = '(prefers-reduced-motion: reduce)';

  function clamp01(n) { return n < 0 ? 0 : (n > 1 ? 1 : n); }

  function armScrollPin(section) {
    if (section.dataset.gsHeArmed === '1') return;
    section.dataset.gsHeArmed = '1';
    section.classList.add('gs-strive-hydration-explained--js');

    var ticking = false;
    var lastProgress = -1;

    function update() {
      ticking = false;

      // Reduced motion: snap to final composition (text fully visible).
      if (window.matchMedia(REDUCED_QUERY).matches) {
        section.style.setProperty('--slide-progress', '1');
        return;
      }

      // Above the mobile breakpoint: clear progress so desktop CSS owns layout.
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        section.style.removeProperty('--slide-progress');
        return;
      }

      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var range = Math.max(1, section.offsetHeight - vh);
      var progress = clamp01(-rect.top / range);

      if (progress === lastProgress) return;
      lastProgress = progress;
      section.style.setProperty('--slide-progress', progress.toFixed(4));
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function armDesktopReveal(section) {
    if (section.dataset.gsHeRevealArmed === '1') return;
    section.dataset.gsHeRevealArmed = '1';

    var callouts = section.querySelectorAll('.gs-strive-hydration-explained__callout');
    if (!callouts.length) return;

    section.setAttribute('data-anim-ready', '');

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35, rootMargin: '0px 0px -10% 0px' }
    );
    callouts.forEach(function (el) { observer.observe(el); });
  }

  function revealAllImmediately(section) {
    var callouts = section.querySelectorAll('.gs-strive-hydration-explained__callout');
    for (var i = 0; i < callouts.length; i++) callouts[i].classList.add('is-visible');
  }

  function arm(section) {
    var prefersReduced = window.matchMedia && window.matchMedia(REDUCED_QUERY).matches;
    var supportsIO = 'IntersectionObserver' in window;

    if (prefersReduced) {
      // Skip both animations. Make sure callouts are visible.
      revealAllImmediately(section);
      return;
    }

    // Always arm the scroll-pin handler — it self-disables above the mobile
    // breakpoint and handles resize transitions across the breakpoint.
    armScrollPin(section);

    // Desktop also gets the per-callout IO reveal. The CSS rules for the
    // reveal are gated by both [data-anim-ready] AND the absence of --js
    // pin styles, so on mobile the slide animation wins.
    if (supportsIO) armDesktopReveal(section);
    else revealAllImmediately(section);
  }

  function boot() {
    document.querySelectorAll('.gs-strive-hydration-explained').forEach(arm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('.gs-strive-hydration-explained')
      : null;
    if (root) arm(root);
  });
})();
